import React from 'react'

import KanbanListProvider from 'providers/KanbanListProvider'
import KanbanBoardProvider from 'providers/KanbanBoardProvider'
import ActivityModalProvider from 'providers/ActivityModalProvider'
import KanbanFiltersProvider from 'providers/KanbanFiltersProvider'
import KanbanColumnStatesProvider from 'providers/KanbanColumnStatesProvider'

const KanbanProviders = ({ children }) => (
  <KanbanBoardProvider>
    <KanbanFiltersProvider>
      <KanbanListProvider>
        <KanbanColumnStatesProvider>
          <ActivityModalProvider>{children}</ActivityModalProvider>
        </KanbanColumnStatesProvider>
      </KanbanListProvider>
    </KanbanFiltersProvider>
  </KanbanBoardProvider>
)

export default KanbanProviders
